import { useState } from "react";
import { CategoriesType } from "../types/server";
import { requestHelper } from "../helpers/request-helper";
import { formatAndRaiseError } from "../helpers/general";

export function useCategories() {
  let [categoriesData, setCategoriesData] = useState<CategoriesType>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrive() {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
          query listCategories {
            listCategories {
              id
              alias
              name
          }
        }
        `
    )
      .then((data) => {
        setCategoriesData({ data });
      })
      .catch(formatAndRaiseError)
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrive, categoriesData, loading, error };
}
